<template>
  <label class="base-select block">
    <span class="block">
      {{ label || name }}
    </span>

    <select @change="handleChange"
            class="w100"
            :value="value">
      <option v-for="(option, index) in options"
              :value="option[optionKey]"
              :key="index">
        {{ option[optionKey] }}
      </option>
    </select>
  </label>
</template>

<script>
  export default {
    name: 'BaseSelect',
    props: {
      name: String,
      label: String,
      optionKey: String,
      options: Array,
      value: String
    },
    methods: {
      handleChange (ev) {
        this.$emit('select', {
          name: this.name,
          value: ev.target.value
        })
      }
    }
  }
</script>

<style lang="less">
  .base-select {
    @media only screen and (min-width: 0) {
      span {
        margin-bottom: 4px;
        font-size: 1.5rem;
      }
      select {
        padding: 8px;
        border-radius: 4px;
        border: 1px solid #dddddd;
        font-size: 1.6rem;
      }
    }
  }
</style>
